<product-card [product]="product"></product-card>

<ng-template [cxOutlet]="ProductListOutlets.ITEM_ACTIONS">
  <ng-container cxInnerComponentsHost></ng-container>
</ng-template>
